import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { getProjects } from '../api/projects';
import t from '../i18n/fr.json';
import '../styles/ICOListing.css';

import planete_ico from '../images/logo_onlineico_v.png';
import pub1 from '../images/pub1.png';
import pub2 from '../images/pub2.png';
import pub3 from '../images/pub3.png';

import planete_ido from '../images/planete_ido.png';
import planete_kyc from '../images/planete_kyc_audit.png';


import banniere from '../images/helpadeal_banner_onlineico_1000x130.png';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';


import Navbar from '../components/Navbar';
import ProjectCard from '../components/ProjectCard';

export default function ICOListing() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [sort, setSort] = useState('trending');
  const [search, setSearch] = useState('');
  const [voted, setVoted] = useState(new Set());
  const [visible, setVisible] = useState(6);
  const [banniereLoaded, setBanniereLoaded] = useState(false);
  const navigate = useNavigate();
  const { user, logoutUser } = useAuth();

useEffect(() => {
    async function fetchProjects() {
        setLoading(true);
        const data = await getProjects({ status: filter, search, sort });
        setProjects(data);
        setLoading(false);
    }
    fetchProjects();

}, [filter, search, sort]);


  const handleVote = (id) => {
    setVoted(prev => new Set([...prev, id]));
  };

  const featured = projects.filter(p => p.has_premium === true);

  const displayed = projects.slice(0, visible);

  const filters = [
    { key: 'all', label: t.filter_all },
    { key: 'live', label: t.filter_live },
    { key: 'upcoming', label: t.filter_upcoming },
    { key: 'ended', label: t.filter_ended },
  ];






  
  return (
    <div className="app-wrap">

<Helmet>
    <title>ICO & IDO Listings | Discover Crypto Presales | OnlineICO</title>
    <meta name="description" content="Browse all active ICO, IDO and crypto presale projects. Filter by blockchain, category and status. Find the next gem before launch." />
    <link rel="canonical" href="https://onlineico.com/listings" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="OnlineICO" />
    <meta property="og:title" content="ICO & IDO Listings | Discover Crypto Presales | OnlineICO" />
    <meta property="og:description" content="Browse all active ICO, IDO and crypto presale projects. Filter by blockchain, category and status. Find the next gem before launch." />
    <meta property="og:url" content="https://onlineico.com/listings" />
    <meta property="og:image" content="https://onlineico.com/og-image.png" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@online_ico" />
    <meta name="twitter:title" content="ICO & IDO Listings | Discover Crypto Presales | OnlineICO" />
    <meta name="twitter:description" content="Browse all active ICO, IDO and crypto presale projects. Filter by blockchain, category and status. Find the next gem before launch." />
    <meta name="twitter:image" content="https://onlineico.com/og-image.png" />

    <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "ICO & IDO Listings | OnlineICO",
        "description": "Browse all active ICO, IDO and crypto presale projects.",
        "url": "https://onlineico.com/listings",
        "publisher": {
            "@type": "Organization",
            "name": "OnlineICO",
            "url": "https://onlineico.com",
            "logo": "https://onlineico.com/logo_onlineico_v.png"
        }
    })}</script>
</Helmet>

<Navbar />
   



{/*   BANNIERE */}
<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', position: 'relative' }}>
  {!banniereLoaded && (
    <div style={{
       width: '100%',
      borderRadius: '12px',
      background: 'rgba(255,255,255,0.06)',
      animation: 'shimmer 1.5s infinite'
    }} />
  )}

<a href='/ico/HELPADEAL'>
  <img
    src={banniere}
    alt="HelpaDeal - Collaborative Security"
    title="HelpaDeal - Collaborative Security"
    onLoad={() => setBanniereLoaded(true)}
    style={{ width: '100%', objectFit: 'cover', display: banniereLoaded ? 'block' : 'none', marginTop:'0px', }}
  /></a>
</div>


<div className="hero">
  <div className="hero-title"><span className="accent">✦ The Crypto ICO & Presale Reference ✦</span></div>
    <p className="hero-sub">Discover, vote and explore the latest crypto ICO presale projects.<br/>
      <span className="accent" style={{
        background: "linear-gradient(135deg, #fff 0%, #FF8C00 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
        }}>onlineico.com, the ICO reference.
      </span>
    </p>
  </div>

  {/* ESPACE PUB */}
  {featured.length > 0 && (
        <div className="featured-strip">
          <div className="featured-label">★ {t.featured_label}</div>
          <div className="featured-cards">
            {featured.map((p, i) => (
             // <ProjectCard key={p.id} project={p} rank={i + 1} voted={voted} onVote={handleVote} />
              <ProjectCard key={p.id} project={p} />
            ))}
          </div>
        </div>
  )}
<div className="featured-strip">
{/* SEPARATEUR */}
<div className="featured-label"></div>    
</div>

      <div className="controls">
        <div className="search-wrap">
          <span className="search-icon">⌕</span>
          <input
            className={`search-input${search ? ' search-input--has-value' : ''}`}
            placeholder={t.search_placeholder}
            value={search}
            onChange={e => { setSearch(e.target.value); setVisible(6); }}
          />
          {search && (
            <button className="search-clear" onClick={() => { setSearch(''); setVisible(6); }}>×</button>
          )}
        </div>
        <div className="filters">
          {filters.map(f => (
            <button
              key={f.key}
              className={`filter-btn${filter === f.key ? ' active' : ''}`}
              onClick={() => { setFilter(f.key); setVisible(6); }}
            >
              {f.label}
            </button>
          ))}
        </div>
        <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
          <option value="votes">{t.sort_votes}</option>
          <option value="recent">{t.sort_recent}</option>
          <option value="trending">{t.sort_trending}</option>
        </select>
      </div>

{/* SEPARATEUR */}
<div className="featured-strip">
  <div className="featured-label"></div>    
</div>

      {loading ? (
        <div className="listing-grid">
          {[...Array(6)].map((_, i) => (
            <div key={i} style={{
              background: 'rgba(10,15,30,0.6)',
              border: '1px solid rgba(255,255,255,0.07)',
              borderRadius: '20px',
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: 'rgba(255,255,255,0.06)', animation: 'shimmer 1.5s infinite' }} />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ height: '14px', borderRadius: '6px', background: 'rgba(255,255,255,0.06)', animation: 'shimmer 1.5s infinite', width: '60%' }} />
                  <div style={{ height: '11px', borderRadius: '6px', background: 'rgba(255,255,255,0.04)', animation: 'shimmer 1.5s infinite', width: '40%' }} />
                </div>
              </div>
              <div style={{ height: '11px', borderRadius: '6px', background: 'rgba(255,255,255,0.04)', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ height: '11px', borderRadius: '6px', background: 'rgba(255,255,255,0.04)', animation: 'shimmer 1.5s infinite', width: '80%' }} />
              <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                <div style={{ height: '32px', borderRadius: '10px', background: 'rgba(255,255,255,0.06)', animation: 'shimmer 1.5s infinite', flex: 1 }} />
                <div style={{ height: '32px', borderRadius: '10px', background: 'rgba(255,255,255,0.06)', animation: 'shimmer 1.5s infinite', flex: 1 }} />
              </div>
            </div>
          ))}
        </div>
      ) : displayed.length === 0 ? (
        <div className="loading">{t.no_results}</div>
      ) : (
        <div className="listing-grid">
          {displayed.map((p, i) => (
           // <ProjectCard key={p.id} project={p} rank={i + 1} voted={voted} onVote={handleVote} />
            <ProjectCard key={p.id} project={p} navigate={navigate} />
          ))}
        </div>
      )}

      {visible < projects.length && (
        <div className="load-more-wrap">
          <button className="load-more-btn" onClick={() => setVisible(v => v + 6)}>
            {t.load_more} ({projects.length - visible})
          </button>
        </div>
      )}

      <div className="cta-bottom">
        <div className="cta-inner">
          <div className="cta-text">
            <h3>{t.submit_cta}</h3>
            <p>Free listing · Promoted option available</p>
          </div>
          <button className="cta-submit-btn" onClick={() => navigate('/add-crypto-project-ico')}>🚀 {t.submit_btn} →</button>
        </div>
      </div>

    </div>
  );
}